<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض بيانات الكود</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>الكود</th>
                    <td>{{ codeInfo.code }}</td>
                  </tr>
                  <tr>
                    <th>الوصف بالعربي</th>
                    <td>{{ codeInfo.description }}</td>
                  </tr>
                  <tr>
                    <th>تاريخ الإنشاء</th>
                    <td>{{ codeInfo.created_at }}</td>
                  </tr>
                </table>
            </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th colspan="3">الطلاب المرتبطون بالكود</th>
                </tr>
                <tr>
                  <th>رقم الطالب</th>
                  <th>اسم الطالب</th>
                  <th>البريد الإلكتروني</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="student in codeInfo.students" :key="student.id">
                  <td>{{ student.id }}</td>
                    <td>{{ student.first_name + ' ' + student.last_name }}</td>
                  <td>{{ student.email }}</td>
                </tr>
                <tr v-if="!codeInfo.students || codeInfo.students.length === 0">
                  <td colspan="3" class="text-center">لا يوجد طلاب مرتبطون بهذا الكود</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowCategory',
  data () {
    return {
      codeInfo: []
    }
  },
  created () {
    this.$http
      .get(`${this.$hostUrl}invitation-codes/${this.$route.params.id}`)
      .then((response) => {
        this.codeInfo = response.data.data.invitation_code
      })
  },
  methods: {
    goBack () {
      this.categoriesOpened ? this.$router.go(-1) : this.$router.push({ path: '/categories' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
